module.exports = {
  "/": {
    "success": {
      "default": [
        "REPORTS_LIST_CONTAINER"
      ]
    },
    "error": [
      "REPORTS_LIST_CONTAINER_FAILURE"
    ]
  },
  "/restore": {
    "success": {
      "default": [
        "RESTORE_REPORTS_LIST_CONTAINER"
      ],
      "restore reports empty": [
        "RESTORE_REPORTS_LIST_CONTAINER_EMPTY"
      ]
    },
    "error": [
      "RESTORE_REPORTS_LIST_CONTAINER_FAILURE"
    ]
  },
  "/tags": {
    "success": {
      "default": [
        "TAG_MANAGER_TABLE_CONTAINER"
      ],
      "tags empty": [
        "TAG_MANAGER_TABLE_CONTAINER_EMPTY"
      ]
    },
    "error": [
      "TAG_MANAGER_TABLE_CONTAINER_FAILURE"
    ]
  },
  "/:reportId": {
    "name": "savedReportSRV",
    "success": {
      "default": [
        "SINGLE_REPORT_VIEWER"
      ]
    },
    "error": [
      "SINGLE_REPORT_VIEWER_FAILURE"
    ]
  },
  "/export/:reportId": {
    "name": "savedReportExport",
    "success": {
      "Export report preview page loaded": [
        "EXPORT_REPORT_PREVIEW_PAGE_LOADED"
      ]
    },
    "error": [
      "EXPORT_REPORT_PREVIEW_PAGE_FAILED"
    ]
  },
  "/templates/:templateId": {},
  "/templates/:collectionId/:templateId": {
    "name": "templatesAnalyticsSuitePage",
    "success": {
      "default": [
        "TEMPLATES_PAGE_CONTAINER"
      ]
    }
  },
  "/collections/:collectionId": {
    "name": "analyticsSuiteHomePage",
    "success": {
      "default": [
        "ANALYTICS_SUITE_HOME_CONTAINER"
      ],
      "analytics suite home page permissions required": [
        "ANALYTICS_PERMISSIONS_REQUIRED"
      ]
    }
  },
  "/collections/:collectionId/:categoryId": {
    "name": "analyticsSuiteCategoryHomePage",
    "success": {
      "default": [
        "ANALYTICS_SUITE_CATEGORY_HOME_CONTAINER"
      ],
      "analytics suite category home page permissions required": [
        "ANALYTICS_PERMISSIONS_REQUIRED"
      ]
    }
  }
};